import ModelUtil from '@leverege/model-util';
import StringUtil from '@leverege/string-util';
import { createImagineAggregationBuilder } from "../AggregationBuilder.js";
const imagineType = 'histogram';
const TYPE = `aggregation.${imagineType}`;
function create() {
  return {
    type: TYPE,
    field: null,
    interval: 10,
    minCount: null,
    extendedBounds: {
      min: null,
      max: null
    },
    offset: null,
    missing: null,
    order: null,
    keyed: false,
    attrName: null
  };
}
function getValueType(model) {
  return 'buckets';
}
function formatBucketKey(bucket, value) {
  return `${bucket.key} - ${bucket.key + value.interval}`;
}
export default {
  create,
  TYPE,
  name: StringUtil.camelCaseToTitleCase(imagineType),
  ...ModelUtil.createAllValue('field'),
  ...ModelUtil.createAllValue('interval'),
  ...ModelUtil.createAllValue('minCount'),
  ...ModelUtil.createAllValue('extendedBounds/min', 'extendedBoundsMin'),
  ...ModelUtil.createAllValue('extendedBounds/max', 'extendedBoundsMax'),
  ...ModelUtil.createAllValue('offset'),
  ...ModelUtil.createAllValue('missing'),
  ...ModelUtil.createAllValue('order'),
  ...ModelUtil.createAllValue('keyed'),
  ...ModelUtil.createAllValue('attrName'),
  toImagineAgg: createImagineAggregationBuilder(imagineType),
  getValueType,
  formatBucketKey
};